var exports = {
  "kL": "x936d19a0--ea337a--container",
  "AS": "x936d19a0--ea337a--item",
  "DD": "x936d19a0--ea337a--title",
};

module.exports = exports;
